import { CatalogTable, CatalogTableColumnsFunc } from '@backstage/plugin-catalog';

export const subscriptionColumns: CatalogTableColumnsFunc = context =>
  CatalogTable.defaultColumnsFunc(context).filter(
    column => column.field !== 'resolved.partOfSystemRelationTitle',
  );
